const curtain = {};

curtain.init = () => {
    setTimeout(function () {
        document.getElementById("curtain").classList.add("hide");
    }, 300);
}

export default curtain;
